import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import React, { HTMLAttributes } from 'react';
import { IconSize } from 'src/interfaces/Icon';
import { SubtitleIcon } from '../../icons';
import IconButton from '../IconButton';
import TooltipWrapper from '../TooltipWrapper';
import styles from './styles.module.scss';

export interface ISubtitleToggleProps {
  isEnabled: boolean;
  onClick: () => void;
  iconSize?: IconSize.small | IconSize.medium;
  className?: string;
}

const ActiveBorder = (props: HTMLAttributes<HTMLDivElement>) => <div {...props} />;

const SubtitleToggle = ({ isEnabled, className, onClick, iconSize = IconSize.medium }: ISubtitleToggleProps) => {
  const { t } = useTranslation('common');
  const tooltipText = isEnabled ? t('tooltips.subtitles.disable') : t('tooltips.subtitles.enable');
  const ariaLabel = isEnabled
    ? t('aria_labels.controls.subtitles.disable')
    : t('aria_labels.controls.subtitles.enable');

  return (
    <TooltipWrapper tooltipText={tooltipText} tooltipPosition='top'>
      <IconButton
        data-testid='subtitle-toggle'
        onClick={onClick}
        className={classNames(styles.subtitleToggle, styles[iconSize], { [styles.enabled]: isEnabled }, className)}
        aria-keyshortcuts='c'
        aria-label={ariaLabel}
        icon={
          <>
            <SubtitleIcon size={iconSize} />
            <ActiveBorder />
          </>
        }
      />
    </TooltipWrapper>
  );
};

export default SubtitleToggle;
